import { apkros } from "./apkros";
import { bessarabca } from "./bessarabca";
import { byrain } from "./byrain";
import { godsforge } from "./godsforge";
import { greymy } from "./greymy";
import { koPlus } from "./ko-plus";
import { lubimPech } from "./lubim-pech";
import { satoshiFriends } from "./satoshi-friends";
import { satoshiNews } from "./satoshi-news";
import { sergeyListopad } from "./sergey-listopad";
import { theSensusCode } from "./the-sensus-code";
import { vosart } from "./vosart";
import { wineshope } from "./wineshope";
import { kalachevo } from "./kalachevo";
import { kukusiki } from "./kukusiki";
import { latmosfera } from "./latmosfera";
import { petsroom } from "./petsroom";
import { reportage } from "./reportage";
import { vilaxii } from "./vilaxii";
import { sevenLombard } from "./7-lombard";
import { aleartDesign } from "./aleart-design";
import { archidica } from "./archidica";
import { artline } from "./artline";
import { cvmarket } from "./cvmarket";
import { esg } from "./esg";
import { gbcvet } from "./gbcvet";
import { levrana } from "./levrana";
import { lombardL1 } from "./lombard-l1";
import { pokrovskieBani } from "./pokrovskie-bani";
import { quantumClinic } from "./quantum-clinic";
import { quantumShop } from "./quantum-shop";
import { restet } from "./restet";
import { sima } from "./sima";
import { styllight } from "./styllight";
import { systemLogistic } from "./system-logistic";
import { timebit } from "./timebit";
import type { CaseStudy } from "./types";

/** Порядок кейсов = порядок переключения «Предыдущий / Следующий проект» */
export const caseStudies: CaseStudy[] = [
  artline,
  archidica,
  esg,
  gbcvet,
  quantumClinic,
  quantumShop,
  cvmarket,
  systemLogistic,
  pokrovskieBani,
  levrana,
  timebit,
  styllight,
  restet,
  lombardL1,
  sevenLombard,
  sima,
  aleartDesign,
  apkros,
  bessarabca,
  byrain,
  godsforge,
  kalachevo,
  kukusiki,
  latmosfera,
  petsroom,
  reportage,
  vilaxii,
  satoshiFriends,
  satoshiNews,
  theSensusCode,
  greymy,
  vosart,
  wineshope,
  koPlus,
  sergeyListopad,
  lubimPech,
];

export const caseSlugs = caseStudies.map((c) => c.slug);

/** Старый URL → новый slug: используется для 301-редиректов */
export const legacyCaseSlugs: Record<string, string> = {
  artlinem: "artline",
};

export function getCase(slug: string): CaseStudy | undefined {
  return caseStudies.find((c) => c.slug === slug);
}

/** Соседние проекты по кругу; при единственном кейсе — пусто */
export function getPrevNext(slug: string): {
  prev?: CaseStudy | undefined;
  next?: CaseStudy | undefined;
} {
  if (caseStudies.length < 2) return {};
  const i = caseStudies.findIndex((c) => c.slug === slug);
  if (i < 0) return {};
  return {
    prev: caseStudies[(i - 1 + caseStudies.length) % caseStudies.length],
    next: caseStudies[(i + 1) % caseStudies.length],
  };
}

export type { CaseStudy } from "./types";
